import { ChangeDetectionStrategy, Component, ElementRef, Input, Renderer2 } from '@angular/core';
import { SessionsPostCardStackBackgroundViewModel } from './sessions-post-card-stack-background-view-model';
import { CardBackgroundComponent } from '../../card-background.component';
import type { CardData } from '../../../../../../../models/print-cards/card-data';

@Component({
  selector: 'app-sessions-post-card-stack-background',
  templateUrl: './sessions-post-card-stack-background.component.html',
  styleUrls: ['./sessions-post-card-stack-background.component.scss'],
  providers: [SessionsPostCardStackBackgroundViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SessionsPostCardStackBackgroundComponent extends CardBackgroundComponent {
  constructor(
    public viewModel: SessionsPostCardStackBackgroundViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }

  @Input() override cardBackground: CardData;
}
